export const getQueryParamFromSearch = (search, param) => {
  const urlSearchParams = new URLSearchParams(search);
  const params = Object.fromEntries(urlSearchParams.entries());

  return params[param];
};
